module.exports = __webpack_public_path__ + "img/04-zichang.babfa36f.png";